<div class="ems-period" *ngIf="displayTable">
    <div class="period-header-bar">
        <span class="period-title">{{ periodLabel }}</span>
        <button type="button" class="add-row-button" (click)="onAddRow()">
            {{ 'aumico_annual_report_ems_add_new_item_button_text' | i18next }}
        </button>
    </div>

    <div class="period-scroll">
        <table class="ems-table">
            <thead>
                <tr
                    class="header-row"
                    cdkDropList
                    cdkDropListOrientation="horizontal"
                    (cdkDropListDropped)="onColumnDrop($event)"
                >
                    <th class="position-col">{{ 'aumico_annual_report_ems_position_column_header' | i18next }}</th>
                    <th
                        *ngFor="let col of columns; trackBy: trackByColumnId"
                        class="value-col"
                        [ngClass]="col.type"
                        cdkDrag
                        cdkDragLockAxis="x"
                        [cdkDragDisabled]="columns.length <= 1"
                    >
                        <ng-template cdkDragPreview>
                            <div class="drag-preview">{{ col.title }}</div>
                        </ng-template>

                        <div class="ems-column-header">
                            <span class="drag-grip ham-icon" cdkDragHandle>
                                <i class="dots-grid-icon"></i>
                            </span>

                            <span class="title-wrap" [class.is-editing]="editingColumnId === col.id">
                                <span class="title" [title]="col.title">{{ col.title }}</span>
                                <input
                                    *ngIf="editingColumnId === col.id"
                                    #titleInput
                                    class="title-input"
                                    [value]="col.title"
                                    (blur)="commitColumnRename(col.id, titleInput.value)"
                                    (keydown.enter)="titleInput.blur()"
                                />
                            </span>

                            <span class="menu-trigger" mat-icon-button [matMenuTriggerFor]="colMenu">
                                <mat-icon svgIcon="aumico-pattern-icon-settings-vertical"></mat-icon>
                            </span>
                            <mat-menu #colMenu="matMenu" class="column-flyout-menu">
                                <button mat-menu-item class="context-option" (click)="startColumnEditing(col.id)">
                                    {{ 'aumico_grouping_masking_bulk_action_rename' | i18next }}
                                </button>
                                <button
                                    *ngIf="col.type !== 'SYSTEM'"
                                    mat-menu-item
                                    class="context-option"
                                    (click)="onColumnDelete(col.id)"
                                >
                                    {{ 'aumico_core_ck_editor_table_column_delete_column' | i18next }}
                                </button>
                                <ng-container *ngIf="col.type === 'TOTAL'">
                                    <div class="divider"></div>
                                    <div class="menu-section-label">
                                        {{ 'aumico_notes_super_table_select_summation_columns_label' | i18next }}
                                    </div>
                                    <button
                                        mat-menu-item
                                        class="context-option"
                                        *ngFor="let source of selectableColumnsFor(col); trackBy: trackBySourceId"
                                        (click)="$event.stopPropagation(); onColumnToggleSource(col.id, source.id)"
                                    >
                                        <span
                                            class="source-checkbox"
                                            hamCheckbox
                                            [checked]="source.selected"
                                            [bubbleEvents]="true"
                                        ></span>
                                        <span>{{ source.title }}</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </div>
                    </th>
                    <th class="remove-col"></th>
                </tr>
            </thead>

            <tbody>
                <tr class="opening-row">
                    <td class="position-col">
                        <ng-container *ngIf="!editingOpeningTitle">
                            <span class="row-title">{{ openingTitle }}</span>
                            <span class="ham-icon edit-title-icon" (click)="startEditingOpeningTitle()">
                                <i class="pen-outline-icon"></i>
                            </span>
                        </ng-container>
                        <input
                            *ngIf="editingOpeningTitle"
                            #openingTitleInput
                            hamInput
                            class="row-title-input"
                            [value]="openingTitle"
                            (blur)="commitOpeningTitle(openingTitleInput.value)"
                            (keydown.enter)="openingTitleInput.blur()"
                        />
                    </td>
                    <td *ngFor="let col of columns; trackBy: trackByColumnId" class="value-col" [ngClass]="col.type">
                        <input
                            *ngIf="col.openingEditable && col.type !== 'TOTAL'; else openingReadonly"
                            hamInput
                            type="number"
                            class="value-input"
                            [hideRemoveXButton]="true"
                            [formControl]="$any(openingGroup.get(col.id))"
                        />
                        <ng-template #openingReadonly>{{ openingValue(col) | finNumber : numberFormat }}</ng-template>
                    </td>
                    <td class="remove-col"></td>
                </tr>
            </tbody>

            <tbody cdkDropList (cdkDropListDropped)="onRowDrop($event)">
                <tr
                    *ngFor="let row of rows.controls; let i = index"
                    class="movement-row"
                    [formGroup]="$any(row)"
                    cdkDrag
                    cdkDragLockAxis="y"
                    [cdkDragDisabled]="rows.length <= 1"
                >
                    <ng-template cdkDragPreview>
                        <div class="drag-preview">
                            {{
                                $any(row).get('name')?.value ||
                                    ('aumico_notes_super_table_text_value_placeholder' | i18next)
                            }}
                        </div>
                    </ng-template>

                    <td class="position-col">
                        <div class="movement-name-cell">
                            <span class="drag-grip ham-icon" cdkDragHandle>
                                <i class="dots-grid-icon"></i>
                            </span>
                            <input
                                hamInput
                                class="movement-name"
                                formControlName="name"
                                [hideRemoveXButton]="true"
                                [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                            />
                        </div>
                    </td>
                    <td *ngFor="let col of columns; trackBy: trackByColumnId" class="value-col" [ngClass]="col.type">
                        <input
                            *ngIf="col.type !== 'TOTAL'; else totalCell"
                            hamInput
                            type="number"
                            class="value-input"
                            [hideRemoveXButton]="true"
                            [formControl]="$any(row.get(['values', col.id]))"
                        />
                        <ng-template #totalCell>{{ cellValue(col, i) | finNumber : numberFormat }}</ng-template>
                    </td>
                    <td class="remove-col">
                        <span class="ham-icon row-remove" (click)="onRemoveRow(i)">
                            <i class="grey-remove-icon"></i>
                        </span>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr class="closing-row">
                    <td class="position-col">
                        <ng-container *ngIf="!editingClosingTitle">
                            <span class="row-title">{{ closingTitle }}</span>
                            <span class="ham-icon edit-title-icon" (click)="startEditingClosingTitle()">
                                <i class="pen-outline-icon"></i>
                            </span>
                        </ng-container>
                        <input
                            *ngIf="editingClosingTitle"
                            #closingTitleInput
                            hamInput
                            class="row-title-input"
                            [value]="closingTitle"
                            (blur)="commitClosingTitle(closingTitleInput.value)"
                            (keydown.enter)="closingTitleInput.blur()"
                        />
                    </td>
                    <td *ngFor="let col of columns; trackBy: trackByColumnId" class="value-col" [ngClass]="col.type">
                        {{ closingValue(col) | finNumber : numberFormat }}
                    </td>
                    <td class="remove-col"></td>
                </tr>

                <tr class="reconciliation-row">
                    <td class="position-col">
                        {{ 'aumico_annual_report_ems_difference_to' | i18next }} {{ closingDate }}
                    </td>
                    <td
                        *ngFor="let col of columns; trackBy: trackByColumnId"
                        class="value-col"
                        [ngClass]="col.type"
                        [ngSwitch]="reconciliation(col).state"
                    >
                        <span *ngSwitchCase="'ok'" class="reconciliation-ok">✓</span>
                        <span *ngSwitchCase="'off'" class="reconciliation-off">
                            {{ $any(reconciliation(col)).amount | finNumber : numberFormat }}
                        </span>
                        <span *ngSwitchCase="'none'" class="reconciliation-none">–</span>
                    </td>
                    <td class="remove-col"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<ham-confirm-decline-modal
    *ngIf="rowPendingDelete != null"
    (cancel)="onCancelRowDelete()"
    (action)="onConfirmRowDelete()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_annual_report_delete_item_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
